import React from "react";
import img1 from "../assets/images/1.png";
import img2 from "../assets/images/2.png";
import img3 from "../assets/images/3.png";

function MobileComponent() {
  return (
    <div className="container">
      <h1 className="mobile-h1">Install Carplayhacks App</h1>
      <br />
      <div className="container">
        <p className="mobile-para">
          You can install <strong>WheelPal App</strong> and
          <strong>InCar app</strong> through the carplayhacks app. Just follow
          the guide below to install the CarPlay Hacks app.
        </p>

        <br />
        <div>
          <strong className="step">Step 1</strong>.
          <p className="mobile-para">
            Visit this page using the Safari browser of your iPhone.
          </p>
        </div>
        <div>
          <strong className="step">Step 2</strong>.
          <p className="mobile-para">
            Tap the <strong>Share</strong> button at the bottom of the screen.
          </p>
          <br />
          <div style={{ textAlign: "center" }}>
            <img src={img1} alt="Paris" width="300" />
          </div>
        </div>
        <br />
        <div>
          <strong className="step">Step 3</strong>.
          <p className="mobile-para">
            Select Add to Home Screen option from the menu.
          </p>
          <br />
          <div style={{ textAlign: "center" }}>
            <img src={img2} alt="Paris" width="300" />
          </div>
        </div>
        <br />
        <div>
          <strong className="step">Step 4</strong>.
          <p className="mobile-para">
            Tap <b>Install</b> button on right top corner
          </p>
          <br />
          <div style={{ textAlign: "center" }}>
            <img src={img3} alt="Paris" width="300" />
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
    </div>
  );
}

export default MobileComponent;
